'use client';

import GitProviderTokenRefreshCard from '@/components/Settings/GitProviderTokenRefreshCard';
import { SettingsHeader } from '../components/SettingsHeader';
import { SettingsTabProps } from '@/types/settings';
import { useProviderDisplayName } from '@/utils/getProviderDisplayName';

export default function AuthTab({ className }: SettingsTabProps) {
  const providerDisplayName = useProviderDisplayName();

  return (
    <div className={className}>
      <div className="motion-stagger flex flex-col gap-6">
        <SettingsHeader
          title="Auth"
          description={`Keep Entelligence connected to ${providerDisplayName}. Reconnect when access expires or scopes change.`}
        />

        <GitProviderTokenRefreshCard />
      </div>
    </div>
  );
}
